const { generateHtmlContent } = require('@/views/fusion/investment/intelligence-create/tools/form');

const fusion__channel_code = {
  label: '渠道号',
  labelTips: generateHtmlContent({
    content: [
      '根据已选中的广告主账户分别添加渠道号信息，可通过下方列表选择切换不同的广告主账户',
      '不允许重复添加相同的渠道号，多个广告主账户之间不允许存在相同的渠道号',
      '不允许添加不存在的渠道号',
    ],
  }),
  rules: {
    required: true,
    message: '请输入渠道号',
    trigger: ['change'],
  },
  formItemProps: {
    class: ['children-form-widget'],
  },
  children: {
    fusion__channel_code_prefix: {
      label: '渠道号前缀',
      hidden: false,
      rules: {
        required: true,
        message: '请输入渠道号前缀',
        trigger: ['change'],
      },
      props: {
        placeholder: '请输入渠道号前缀',
        style: {
          width: '150px',
          marginRight: '20px',
        },
        class: 'mr-20',
      },
      formItemProps: {
        class: 'pt-0',
      },
      value: '',
    },
    fusion__channel_code_begin_num: {
      label: '渠道起始编号',
      type: 'input-number',
      hidden: false,
      rules: {
        required: true,
        message: '请输入渠道起始编号',
        trigger: ['change'],
      },
      props: {
        step: 1,
        min: 1,
        max: 99999999,
      },
      value: '',
    },
    fusion__channel_code_count: {
      label: '渠道生成数',
      type: 'input-number',
      hidden: false,
      rules: {
        required: true,
        message: '请输入渠道生成数',
        trigger: ['change'],
      },
      props: {
        step: 1,
        min: 1,
        max: 99999999,
      },
      value: '',

    },
    fusion__channel_codes: {
      label: '',
      value: [],
      tabIndex: 0,
      rules: [
        {
          required: true,
          message: '请点击添加渠道',
          trigger: ['change'],
        },
        {
          required: true,
          trigger: ['change'],
          message: '每广告主账户下渠道数需≥1',
          validator: (rule, value, callback) => {
            const valid = value.every(({ list = [] }) => list.length >= 1);
            valid ? callback() : callback(new Error(rule.message));
          },
        },
      ],
      isBox: true,
    },
  },
  value: {},
};

const delivery_platform_type = {
  label: '投放平台',
  type: 'radio-group',
  isButton: true,
  rules: {
    required: true,
    message: '请选择投放平台',
    trigger: ['change'],
  },
  options: [],
  value: '',
};

const delivery_content_id = {
  label: '投放内容',
  type: 'select',
  rules: {
    required: true,
    message: '请选择投放内容',
    trigger: ['change'],
  },
  props: {
    style: {
      display: 'inline-block',
    },
  },
  isPreview: false,
  options: [],
  value: '',
  backup_value: '',
};

/**
 * 广告：投放游戏配置
 */
export {
  fusion__channel_code, // 渠道号
  delivery_platform_type, // 投放平台
  delivery_content_id, // 投放内容
};
